export const LoginApi = "/login/";
export const SwitchRoleLoginApi = "/login/";
export const LogOutApi = "/logout/";
export const forgotPasswordApi = "/users/forgot-password/";
export const verifyOtpApi = "/verify-otp/";
export const resendOtpApi = "/users/resend-otp/";
export const forgotPassOTPcheckApi = "/forgotpassotpcheck/";
export const resetPasswordApi = "/users/reset-password-confirm/";

export const jrfSearchApi = "/jrf/search/";
export const referenceDataApi = "/referenceData/";
export const JRFDeleteApi = "/jrf/delete";
export const JRFPDFDownloadApi = "/jrf_pdf/get";
export const JIAllPdfsApi = "/ji-all-pdfs/get/";
export const JRFGetApi = "/jrf/get";
export const pdfDetailsApi = "/pdfdetails/get";

export const MasterListApi = "/masters/list";
export const MasterCreateApi = "/masters/create/";
export const MasterDeleteApi = (model,fieldName,id) => `/masters/delete/?model_name=${model}&${fieldName}=${id}`;
export const MasterGetApi = (model,fieldName,id) => `/masters/get/?model_name=${model}&${fieldName}=${id}`;
export const MasterUpdateApi = (model,fieldName,id) => `/masters/update/?model_name=${model}&${fieldName}=${id}`;

export const HistoryApi = "/users/object-history/";
export const HistoryApiCustom = "/job_history/list/";
export const sampleDetailsAPI = "/sampleinward/create";
export const sampleInwardDetailsDeleteAPI = "sampleinward/delete";
export const sampleInwardDetailsGetAPI = "/sampleinward/get";
export const sampleInwardDetailsUpdateAPI = "/sampleinward/update";
export const sampleInwardSetDetailsUpdateAPI = "/sampleinward-set/update";
export const sampleInwardUpdate = "/sampleinward/update";
export const sampleIdsApi = "/sampleids/";
export const checkSampleIdAvailable = "/checksampleidexists/get/";

export const allotmentCreateApi = "/allotment/create";
export const allotmentUpdateApi = "/allotment/update";
export const allotmentDeleteApi = "/allotment/delete";
export const allotmentCancelApi = "/allotment/cancel";
export const getSimgleAllotmentDetailsApi = "/allotment/get";

export const sampleverificationdetailCreateApi =
  "/sampleverificationdetail/create";
export const sampleverificationdetailDeleteApi =
  "/sampleverificationdetail/delete/";
export const sampleverificationdetailUpdateApi =
  "/sampleverificationdetail/update";
export const getsamplelabcodeApi = "/samplelabcode/get";

export const sampleverificationCreateApi = "/sampleverification/create";
export const sampleverificationUpdateApi = "/sampleverification/update";
export const sampleverificationDeleteApi = "/sampleverification/delete";
export const sampleverificationSingleApi = "/sampleverification/get";
export const labparametersApi = "/labparameters/get";
export const labGrouoparametersApi = "/lmsgrouporparam/get";
export const OPESGrouoparametersApi = "/opsgrouporparam/get";
export const labGroupsStdBasisApi = "/groupstdbasis/get";
export const labOPEGroupsStdBasisApi = "/opsstdbasis/get";
export const labparambasisApi = "/parambasis/get/";
export const labOPEparambasisApi = "/opsparambasis/get/";
export const labdropdownApi = "/labdropdown/get/";
export const statuscountApi = "/statuscount/";

export const testMemoGetApi = "/testmemo/get";
export const testReportGetApi = "/testreport/get";
export const testMemoGetSamplesetsApi = "/samplesets/get";
export const testMemoGetParambasisstdApi = "/parambasisstd/get";
export const testMemoCreateasyncApi = "/testmemo/create";
export const testMemoDeleteApi = "/testmemo/delete";
export const testMemoUpdateApi = "/testmemo/update";
export const geChemistUserApi = "/chemistuser/get";
export const scopenonscopecountApi = "/scopenonscopecount/get/";

export const SFMCreateApi = "/sfm/create";
export const SFMUpdateApi = "/sfm/update";
export const SFMDeleteApi = "/sfm/delete";
export const SFMGetApi = "/sfm/get";
export const SFMSetCountApi = "/sfmstatuscount/get";
export const SFMbasisupdateApi = "/sfmbasisupdate/update";
export const SFMRejectFlowApi = "/sfmrejectflow/";

export const InternalCertificateCreateApi = "/internalcertificate/create";
export const InternalCertificateUpdateApi = "/internalcertificate/update";
export const InternalCertificateDeleteApi = "/internalcertificate/delete";
export const InternalCertificateGetApi = "/internalcertificate/get";
export const testReportDetailsApi = "/testreportdetails/get";
export const checkexistingulrnoApi = "/checkexistingulrno/get/";
export const SFMUnitUpdateApi = "/sfm_unit/update/"

export const refreshApi = "/api/token/refresh/";
export const formulaListapi = "/formula/list/";
export const formulagetapi = "/formula/get/";
export const formulaCreateapi = "/formula/create/";
export const InternalCertificateGetPDFApi = "/testreportpdf/create"
export const jrfAllLMSReportsApi = "/jrf/all-lms-reports/";
//Operations Apis
export const getClientListDataApi = "/masters/customer/list/";
export const getPlaceDataApi = "masters/placeofwork/list/";
export const getSubplierDataApi = "masters/supplier/list/";
export const getSubCommodityDataApi = "/ji-commodity/get/";
export const getClientDataApi = "/ji-client/get/";
export const getOperationTypeDataApi = "/masters/opmaster/list/";
export const getActivityDataApi = "/masters/activitymaster/list/";
export const getActivityDatabyOperationApi = "/activitydropdown/list/";
// export const getscopeofworkDataApi="/masters/scopeofwork/list/"
export const getscopeofworkDataApi = "/scopeofworkdropdown/get/";
export const getAllPortDataApi = "/masters/port/list/";
export const getScopeworkCreateApi = "/ji-scopeofwork/create/";
export const getScopeworkUpdateApi = "/ji-scopeofwork/update/";
export const getScopeworkDeleteApi = "/ji-scopeofwork/delete/";
export const getScopeworkSingleDataApi = "/ji-scopeofwork/get/";
export const getJIQualityAnalysisCreateApi = "/ji-quality-analysis/create/";
export const getJIQualityAnalysisUpdateApi = "/ji-quality-analysis/update/";
export const getJIQualityAnalysisDeleteApi = "/ji-quality-analysis/delete/";

export const getBranchDetailsApi = "/ji-branch/get/";
export const getJIsowandactivityApi = "/ji-sowandactivity/list/";
export const getReportConfigApi = "/report-config/list/";
export const getCommercialCertificateListApi = "/commercial-cert/list/";

export const TMLDataCreateApi = "/ji-samplemarks/create/";
export const TMLDataUpdateApi = "/ji-samplemarks/update/";
export const TMLDatagetAllApi = "/ji-samplemarks/list/";
export const TMLDataDeleteApi = "/ji-samplemarks/delete/";
export const TMLAnalysisDataCreateApi = "/ji-lms-assignment/create/";
export const TMLAnalysisDataListApi = "/ji-lms-assignment/list/";
export const sampleMarkOptionsApi = "ops-samplemarks/get/";
export const sampleMarkOptionsLotWiseApi = "/lotwise-samplemark/get/";
export const getJRFOperationDataApi = "/ops_lms_data/get/";
export const deleteTMLAnalysisDeleteApi = "/ji-lms-assignment/delete/";

export const jobinstructionUpdateApi = "/jobinstruction/update/";
export const jobinstructionDeleteApi = "/jobinstruction/delete/";
export const createOtherTpiApi = "/tpi-async-task/create/";
export const updateOtherTpiApi = "/tpi-main/update/";
export const getTpiSetApi = "/tpi-set/get/";
export const getTpiParamBasistApi = "/tpi-paramstdbasis/get/";
export const getTpibasisvalueUpdateApi = "/tpi-basisvalue/update/";
export const TPISetCountApi = "/tpi-markcount/get/";
export const notificationListApi = "/notifications/list/";
export const unreadNotificationCountApi = "/notifications/unread-count/";
export const readNotificationApi = (notifyid) => `/notifications/${notifyid}/read-status/`
export const createHHApi = "/ops-vessel-hh/create/";
export const updateHHApi = "/ops-vessel-hh/update/";
export const getHHApi = "/ops-vessel-hh/get/"
export const createSVApi = "/ops-vessel-sv/create/";
export const updateSVApi = "/ops-vessel-sv/update/";
export const getSVApi = "/ops-vessel-sv/get/";
export const createDSApi = "/ops-vessel-ds/create/";
export const updateDSApi = "/ops-vessel-ds/update/";
export const getDSApi = "/ops-vessel-ds/get/";
export const getSalesPersonApi = "/sales-user/list/";
export const createOPSExecApi = "/opsexec-grpparam/create/";
export const getOPSExecApi = "/opsexec-grpparam/list/";
export const deleteOPSExecApi = "/opsexec-grpparam/delete/";
export const getlotnodropdownApi = "lotnodropdown/get/";
export const getAssignemtnLabDropdownApi = "/lab-dropdown/list/"
export const opsSizeAnalysisCreateApi = "/ops-sizeanalysis/create/"
export const opsSizeAnalysisUpdateApi = "/ops-sizeanalysis/update/"
export const opsSizeAnalysisGetApi = "/ops-sizeanalysis/get/"
export const getLastStepAssignmentData = "/lab-dropdown-lmsassignment/get/"
export const getLabWiseSetAssignmentData = "/labwise-set/get/"
export const getfirstrefnumberApi = "/firstrefnumber/list/"
export const getConsortiumOrderApi = "/consortium-order/list/"
export const getOperationTypeApi = "/masters/opmaster/list/"
export const getJIForPreviewApi = "/jobinstruction/preview/"
export const getActivityListDatabyjiApi = "/activity-dropdown/list/";
export const createManPowerApi = "/vessel-manpower/create/";
export const updateManPowerApi = "/vessel-manpower/update/";
export const getManPowerApi = "/vessel-manpower/list/";
export const getInvoiceDetailsApi = "/invoice-details/list/";
export const getInvoiceRetriveApi = "/invoices/get/";
export const InvoiceDeleteApi = "/invoices/delete/";
export const deleteManPowerApi = "/vessel-manpower/delete/";
export const documentShareCreate = "/document_shares/create/";
export const documentShareUpdate = "/document_shares/update/";
export const documentShareDelete = "/document_shares/delete/";
export const documentUpdate = "/documents/update/";
export const checkexistingCertinoApi = "/unique-cert-number/get/";



export const documentListApi = "/documents/list/";
export const documentCreateApi = "/documents/create/";
export const documentDeleteApi = "/documents/delete/";
export const documentGetApi = "/documents/get/";
export const folderCreateApi = "/folder/create/";
export const ccUpdateApi = "/commercial-cert/update/";
export const bulk_cc_update_to_trans_userAPI = "/bulk_cc_update_to_trans_user/update/";
export const bulk_ic_update_to_trans_userAPI = "bulk_ic_update_to_trans_user/update/";
export const dsSurveyPdfApi = "/draft-survey-pdf/";
export const ccCertPdfApi = "/comercial-certificate-pdf/";
export const ccCertWordApi = "/comercial-certificate-word/";
export const ccCertSignApi = "/comercial-certificate-pdf-signature/";
export const ccCertGetApi = "/commercial-cert/get/";
export const ccCertCreateApi = "/commercial-cert/create/";
export const mergeFilesApi = "/merge_files/";
export const masterUploadApi = "/masters/upload/";
export const setwiseDataGetApi = "/setwise-data/get/";
export const certificateReservationCreateApi = "/certificate-reservation/create/";
export const certificateReservationListApi = "/certificate-reservation/list/";
export const certificateReservationGetApi = "/certificate-reservation/get/";
export const certificateReservationUpdateApi = "/certificate-reservation/update/";
export const certificateReservationDeleteApi = "/certificate-reservation/delete/";
export const certConfigCreateApi = "/certificate-config/create/";
export const certConfigUpdateApi = "/certificate-config/update/";
export const certConfigGetApi = "/certificate-config/get/";
export const reportConfigGetApi = "/report-config/get/";
export const reportConfigUpdateApi = "/report-config/update/";
export const reportConfigCreateApi = "/report-config/create/";
export const reportConfigDeleteApi = "/report-config/delete/";
export const reportHeaderFooterCreateApi = "/report-header-footer/get/";
export const emailSuggestionApi = "/email_suggestions/";
export const JRFGetPDFApi = "/generate-jrf-pdf/"
export const H_H_PdfApi = "/hatch-hold-pdf/";
export const supervisionPdfApi = "/supervision-pdf/";
export const getQualityAssesmentApi = "/rake-quality-assessment/get/"
export const createQualityAssesmentApi = "/rake-quality-assessment/create/"
export const updateQualityAssesmentApi = "/rake-quality-assessment/update/"

export const getQualityAnalysisApi = "/rake-quality-analysis/get/"
export const createQualityAnalysisApi = "/rake-quality-analysis/create/"
export const updateQualityAnalysisApi = "/rake-quality-analysis/update/"

export const updateTruckSealingApi = "/truck-sealing/update/";
export const createTruckSealingApi = "/truck-sealing/create/";
export const getTruckSealingApi = "/truck-sealing/get/";
export const updateCargoSupervisionApi = "/truck-cargo-sup/update/";
export const createCargoSupervisionApi = "/truck-cargo-sup/create/";
export const getCargoSupervisionApi = "/truck-cargo-sup/get/";
export const testMemoPDFDownloadApi = "/testmemosfmpdf/get/";
export const getSupervissionVesselInfoApi = "/supervision-vessel-info/";
export const getSamplingMethodsApi = "/samplingmethods/get/";
export const getCompanyBranchApi = "/company-branches/get/";
export const getLoadingPortDataApi = "/countrywise-port/get/";

export const truckSealingPdfApi = "/truck-sealing-pdf/";
export const truckQAPdfApi = "/truck-daily-tm-pdf/";
export const truckQA2PdfApi = "/truck-quality-sampling-pdf/";
export const rakeAssessPdfApi = "/qty-assess-pdf/";
export const rakeQAPdfApi = "/rake-quality-analysis-pdf/";
// export const stackQAPdfApi = "/quality-analysis-pdf/";
export const stackQAPdfApi = "/stack-quality-analysis-pdf/";
export const truckCSPdfApi = "/cargo-sup-pdf/";
export const consortiumDeleteApi = "/consortium-order/delete/";
export const plantQAPdfApi = "/plant-quality-analysis-pdf/";


export const createInvoiceApi = "/invoice-details/create/";
export const updateInvoiceApi = "/invoice-details/update/";
export const deleteInvoiceApi = "/invoice-details/delete/";
export const downloadDraftInvoiceApi = "/invoice/pdf/";

// Srushti
export const getSingleJobCosting = "/job-costing/get/"
export const getSingleBranchExpense = "/expense/get/"
export const getSingleOutstanding = "/outstanding/get/"

// ----------------------------------------------------------------
export const getReferenceWiseDataApi = "/reference-wise-data/";

export const dailyReportPDFApi = "/daily-report-pdf/";
export const OPSJRFDeleteApi = "/ops-jrf/delete/";

export const oustandingCreateApi = "/outstanding/create/";
export const oustandingUpdateApi = "/outstanding/updates/";
export const monthlyOutstanding = "/outstanding/monthly-sale";
export const yearlyOutstanding = "/outstanding/yearly-sale";

export const getSingleSalesRegister = "/saleregister/get/"
export const salesregisterCreateApi = "/saleregister/create/";
export const SalesRegisterUpdateApi = "/saleregister/update/";
export const monthlySalesRegister = "/saleregister/monthly-sale/";
export const yearlySalesRegister = "/saleregister/monthly-sale/";

export const purchaseRequistionUpdateApi = (requestNo) => `/purchase-requisitions/update/?req_no=${requestNo}`;
export const purchaseRequistionDeleteApi = (requestNo) => `/purchase-requisitions/delete/?req_no=${requestNo}`;
export const purchaseRequistionCreateApi = "/purchase-requisitions/create/";
export const purchaseRequistionGetApi = (requestNo) => `/purchase-requisitions/get/?req_no=${requestNo}`;
export const purchaseRequistionDownload = "/purchase-requistion-pdf/"

export const purchaseRequistionTableDataUpdateApi = (prId) => `/purchase-requisition-details/update/${prId}/`;
export const purchaseRequistionTableDataDeleteApi = (prId) => `/purchase-requisition-details/delete/${prId}/`;
export const purchaseRequistionTableDataCreateApi = "/purchase-requisition-details/create/";
export const purchaseOrderGetApi = (prId) => `/purchase-requisition-details/get/${prId}/`;

export const purchaseOrderUpdateApi = (poId) => `/purchase-order/update/${poId}/`;
export const purchaseOrderDeleteApi = (poId) => `/purchase-order/delete/${poId}/`;
export const purchaseOrderCreateApi = "/purchase-order/create/";
export const purchaseOrderGet_Api = (poId) => `/purchase-order/get/${poId}/`;
export const purchaseOrderDownload = "/purchase-order-pdf/"
export const purchaseOrderDownloadItems = (poId) => `/purchase-order-items/excel/${poId}/`
// export const purchaseOrderInsuranceDownload ="/insurance_excel/create/"
export const purchaseOrderInsuranceDownload = "/insurance/excel/"
// export const purchaseOrderVenRatingDownload = "/vendor_rating_excel/create/"
export const purchaseOrderVenRatingDownload = "/vendor-ratings/export-excel/"
export const purchaseOrderRemindApi = "/purchase-order/send-reminder/"



export const SupplierUpdateApi = (id) => `/suppliers/update/${id}/`;
export const SupplierDeleteApi = (id) => `/suppliers/delete/${id}/`;
export const SupplierCreateApi = "/suppliers/create/";
export const SupplierGetApi = (id) => `/suppliers/get/${id}/`;

export const calibrationUpdateApi = "/calibration/update/";
export const calibrationDeleteApi = "/calibration/delete/";
export const calibrationCreateApi = "/calibration/create/";
export const calibrationGetApi = "/calibration/get/";

export const BranchMasterUpdateApi = (id) => `/purchase_branch/${id}/`;
export const BranchMasterDeleteApi = (id) => `/purchase_branch/${id}/`;
export const BranchMasterCreateApi = "/purchase_branch/create/";
export const BranchMasterGetApi = (id) => `/purchase_branch/${id}/`;

// Departmentmaster

export const DepartmentMasterUpdateApi = () => `/masters/department/update/`;
export const DepartmentMasterDeleteApi = (id) => `/masters/delete/?model_name=department&dept_id=${id}`;
export const DepartmentMasterCreateApi = "/masters/department/create/";
export const DepartmentMasterGetApi = (id) => `/masters/get/?model_name=department&dept_id=${id}`;

export const createBulkCargoApi = "/bulk-cargo/create/";
export const updateBulkCargoApi = "/bulk-cargo/update/";
export const getBulkCargoApi = "/bulk-cargo/get/"
export const createBulkInvoices = "/invoice-details/create/"

export const tenderUpdateApi = (tenderId) => `/tender/update/?tender_id=${tenderId}`;
export const tenderDeleteApi = (tenderId) => `/tender/delete/?tender_id=${tenderId}`;;
export const tenderCreateApi = "/tender/create/";
export const tenderGetApi = (tenderId) => `/tender/get/?tender_id=${tenderId}`;

export const chemicalStocksUpdateApi = (chemicalStockId) => `/chemist-stock/update/${chemicalStockId}/`;
export const chemicalStocksDeleteApi = (chemicalStockId) => `/chemist-stock/delete/${chemicalStockId}/`;
export const chemicalStocksCreateApi = "/chemist-stock/create/";
export const chemicalStocksGetApi = (chemicalStockId) => `/chemist-stock/get/${chemicalStockId}/`;

// Transfer Stocks 
export const transferStocksUpdateApi = () => `/stock-transfer/update/`;
export const transferStocksDeleteApi = "/stock-transfer/delete/";
export const transferStocksCreateApi = "/stock-transfer/create/";
export const transferStocksGetApi = (transferStockId) => `/stock-transfer/get/?st_transfer_id=${transferStockId}`;

// --- ${incentiveId}
export const IncentiveUpdateApi = (incentiveId) => `/incentive/update/${incentiveId}/`;
export const IncentiveDeleteApi = (incentiveId) => `/incentive/delete/${incentiveId}/`;
export const IncentiveCreateApi = "/incentive/create/";
export const IncentiveGetApi = (incentiveId) => `/incentive/get/${incentiveId}/`;

export const FeedbackUpdateApi = (feedbackId) => `/feedback/update/${feedbackId}`;
export const FeedbackDeleteApi = (feedbackId) => `/feedback/delete/${feedbackId}`;
export const FeedbackCreateApi = "feedback/create/";
export const FeedbackGetApi = (feedbackId) => `/feedback/get/${feedbackId}`;

// Category
export const CategoryUpdateApi = (categoryId) => `/category-master/update/${categoryId}/`;
export const CategoryCreateApi = "/category-master/create/";
export const CategoryGetApi = (categoryId) => `/category-master/get/${categoryId}/`;
export const CategoryDeleteApi = (categoryId) => `/category-master/delete/${categoryId}/`;

// AMC
export const AMCUpdateApi = (amcId) => `/amc/update/${amcId}/`;
export const AMCCreateApi = "/amc/create/";
export const AMCGetApi = (amcId) => `/amc/get/${amcId}/`;
export const AMCDeleteApi = (amcId) => `/amc/delete/${amcId}/`;
export const AMCExcelDownload = "/amc/export/"

export const bulkCargoPDF = "/bulk-cargo-pdf/"
export const physicalAnalysisPDF = "/vessel-size-analysis/get/"
export const tmlMoisturePDFApi = "tml-moisture-pdf/"


export const opsStackSVCreateApi = "/ops-stack-sv/create/"
export const opsStackSVUpdateApi = "/ops-stack-sv/update/"
export const opsStackSVDeleteApi = "/ops-stack-sv/delete/"
export const opsStackSVGetApi = "/ops-stack-sv/list/"
export const opsStackSVPDFApi = "/stack-supervision-pdf/"

export const getSampleAnalyzedDataApi = "/samples-analysis-per-client-commodity/"
export const getUserSampleHeatMapApi = "/user-samples-heatmap/"
export const getClientRevenueChartApi = "/client-revenue-chart/"
export const getAnalyticsSampleAnalyzedApi = "/analytics/samples-analyzed/"
export const getAnalyticsSampleSubmissionTrendApi = "/analytics/sample-submission-trend/"
export const getPortLoadingUnloadingApi = "/analytics/port-loading-unloading-count/"
export const getBranchLoadingUnloadingApi = "/analytics/branch-loading-unloading-count/"
export const getExternalSampleCountApi = "/analytics/sample-submitted-by-external-client/"
export const getMonthSalesTrendApi = "/analytics/sales-trend/"
export const getClientPaymentStackbarApi = "/analytics/client-payment-stacked-bar/"
// export const getPortLoadingUnloadingCountApi = "/analytics/port-loading-status/"
export const getPortLoadingUnloadingCountApi = "/analytics/kpi-loading-unloading-count/"
export const getClientPaymentCountApi = "/analytics/client-payment-status/"
export const getAVGSampleAnalysusCountApi = "/analytics/avg-sample-analysis-per-analyst/"
export const getCommodityHandlesCountApi = "/analytics/unique-commodities-handled/"
export const getCostingExpenseCountApi = "/analytics/costing-and-expense/"
export const getClientPaymentTableDataApi = "/analytics/kpi-client-payment-status/"
export const getSalesPersonPerformanceTableDataApi = "/analytics/salesperson-performance/"
export const getStateWisePaymentDataApi = "/analytics/state-wise-revenue/"
export const getCommodityWiseSalesDataApi = "/analytics/commodity-wise-sales/"
export const getOPSModeWiseJobsDataApi = "/analytics/mode-wise-count/"
export const getOverallSalesPersonPerformanceApi = "/analytics/sales-performance-report/"
export const getOverallBranchOutstandingApi = "/analytics/branch-outstanding-report/"
export const getOverallcommodityOutstandingApi = "/analytics/commodity-outstanding-report/"
export const getAllPurchaseAnalyticsDataApi = "/analytics/"
export const getAllPurchaseInventoryAnalyticsDataApi = "/analytics/inventory/"
export const getMonthlyPaymentRecievedDataApi = "/analytics/monthly-payment-received/"
export const getBranchwiseCreditNoteDataApi = "/analytics/credit-note-branch/"
export const getSalesPersonwiseCreditNoteDataApi = "/analytics/credit-note-salesperson/"


export const opsRakeSVCreateApi = "/ops-rake-sv/create/"
export const opsRakeSVUpdateApi = "/ops-rake-sv/update/"
export const opsRakeSVDeleteApi = "/ops-rake-sv/delete/"
export const opsRakeSVGetApi = "/ops-rake-sv/list/"
export const opsRakeSVPDFApi = "/rake-supervision-pdf/"

export const ccCertDeleteApi = "/cc-and-config/delete/"
export const invoiceUpdateApi = "/invoices/update/"
export const getJiForCCApi = "/jobinstructioninfo/get/"
export const getStatisticsDataApi = "/metrics/"
export const getConfigDetailsByTenant = "/system-config/get/"
export const courierBulkCreateApi = "/invoices/bulk-courier-update/"


export const announementListApi = "/announcement/list/";

export const itemsnUpdateApi = "/item-master/update/";
export const itemsDeleteApi = "/item-master/delete/";
export const itemsCreateApi = "/item-master/create/";
export const itemsGetApi = "/item-master/retrieve/";

export const jobCostingIncApi = "/job-costing-details/get/";
export const jobCostingMultipleApproveRejectApi = "/job-costing/bulk-approve-reject/";
export const getWorkAnniversary = "/work-anniversary-notifications/list/"
export const getBirthday = "/birthday-notifications/list/"

export const getSliderListApi = "/slider/list/"

export const usersUpdateApi = "/users/update/";
export const usersDeleteApi = "/users/delete/";
export const usersCreateApi = "/users/create/";
export const usersGetApi = "/users/get/";


export const clientUpdateApi = "/masters/customer/update/";
export const clientGetApi = "/masters/customer/get/";
export const approvalVerificationApi = "/approval-otp/";

export const POVendorMailApi = "/purchase-orders/send-vendor-email/";

export const createPOInsuranceApi = "/insurance/create/";
export const updatePOInsuranceApi = "/insurance/update/";
export const getPOInsuranceBYPRDIDApi = "/insurance/get-by-prd/";
export const deletePOInsuranceApi = "/insurance/delete/";
export const onAccountGetApi = "/on-accounts/get/";
export const onAccountCreateApi = "/on-accounts/create/";
export const onAccountUpdateApi = "/on-accounts/update/";
export const onAccountDeleteApi = "/on-accounts/delete/";
export const onAccountListApi = "/on-accounts/list/";

export const clientOutstandingPaymentRemarkApi = "client-outstanding/add-remark/"
export const vendorRatingCreateApi = "/vendor-ratings/create/";
export const vendorRatingUpdateApi = (id) => `/vendor-ratings/update/${id}/`;
export const vendorRatingListApi = "/vendor-ratings/list/";

export const creditNoteCreateApi = "/credit-notes/create/";
export const creditNoteUpdateApi = (id) => `/credit-notes/${id}/update/`;
export const creditNoteApproveApi = (id) => `/credit-notes/${id}/approve/`;
export const getCreditNoteApi = (id) => `/credit-notes/${id}/`;
export const creditNoteDeleteApi = (id) => `/credit-notes/${id}/delete/`;
export const creditNoteBulkActionApi = `/credit-notes/bulk-approve-reject/`;
export const itemDetailsFromItemID = (id, item_id) => `/item-stock/dropdown-for-pr/?branch_id=${id}&item_id=${item_id}`;
export const poDashboardExport = "purchase-orders/dashboard-excel/"

export const JRFUpdateApi = "/jrf/update";
export const getSingleBranchSalesApi = "branch-sales/get/"
export const getmonthlyInvoiceData = "/invoice/monthly-summary/"
export const getCertificateReservationApi = "/certificate-reservation/assign/"


export const getAllChatUsersApi = "/chat/users/search/"
export const createNewConvertionApi = "/chat/conversations/"
export const getAllConvertionsApi = '/chat/conversations/';
export const getAllChatMessagesApi = (conversation_id) => `/chat/conversations/${conversation_id}/messages/`;
export const readConversionApi = (conversation_id) => `/chat/conversations/${conversation_id}/read/`;
export const sendMessageApi = '/chat/messages/';